import { Dispatch, FC, SetStateAction, useState, useCallback, useEffect } from 'react'
import { StackLayout } from '@progress/kendo-react-layout'
import { Window } from '@progress/kendo-react-dialogs'
import { YearSetting } from './YearSetting'
import { Button } from '@progress/kendo-react-buttons'
import { ConfirmDialog, ErrorMessage } from '../../components/parts'
import { CommonActions, useAppDispatch, useAppSelector } from '../../stores'
import { Authority } from '../../gateway/system/Authority'

export interface YearSettingInputProps {
  onCloseEditWindow: () => void
  refetchHomeInformation: () => void
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
}

export const YearSettingInput: FC<YearSettingInputProps> = (props) => {
  const [confirmDialogShow, setConfirmDialogShow] = useState(false)
  const [title, setTitle] = useState('')
  const [args, setArgs] = useState([''])
  const [dialogMsgId, setDialogMsgId] = useState('I003')
  const [renderCancelButton, setRenderCancelButton] = useState(true)
  const userProp = useAppSelector((x) => x.common.userProp)
  const displayStartYear = useAppSelector((x) => x.common.displayStartYear)
  const dispatch = useAppDispatch()

  // 年度DRLの初期値を設定
  const getInitialYear = useCallback((): string => {
    if (displayStartYear !== null && displayStartYear !== '') {
      return String(displayStartYear)
    }
    // 現在の日付を基に年度を計算（4月始まり）
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    // 4月(月番号3)より前なら前年度扱い
    const fiscalYear = currentMonth < 3 ? currentYear - 1 : currentYear
    // 初期表示は現在年度の-1年
    return String(fiscalYear - 1)
  }, [displayStartYear])

  const [selectedYear, setSelectedYear] = useState<string>(getInitialYear())

  useEffect(() => {
    setSelectedYear(getInitialYear())
  }, [getInitialYear])

  /**
   * 登録ボタン押下
   */
  const handleClickLoginBtn = () => {
    // ストアのdisplayStartYearに選択した年度を設定
    if (selectedYear !== undefined && selectedYear !== '') {
      dispatch(CommonActions.setDisplayStartYear(selectedYear))
    }

    // 完了ダイアログを表示
    setConfirmDialogShow(true)
    setTitle('登録完了')
    setDialogMsgId('I004')
    setRenderCancelButton(false)
    setArgs(['登録'])
  }
  /**
   * 戻るボタン押下
   */
  const handleReturn = () => {
    setConfirmDialogShow(true)
    setTitle('戻る')
    // TODO 差分チェックは行っておらず、必ず破棄の確認が出る状態になっている
    setDialogMsgId('I003')
  }
  /**
   * Dialog 確認ボタン
   */
  const handleConfirmEvent = () => {
    if (title === '戻る') {
      setConfirmDialogShow(false)
      setArgs([''])
      setDialogMsgId('I003')
      props.onCloseEditWindow()
      props.refetchHomeInformation()
    }

    if (title === '登録完了') {
      setArgs([''])
      setConfirmDialogShow(false)
      setRenderCancelButton(true)
    }
  }

  return (
    <>
      <Window
        title={'年度の編集'}
        onClose={props.onCloseEditWindow}
        initialWidth={300}
        initialHeight={160}
        modal
      >
        <YearSetting
          value={selectedYear}
          onChange={setSelectedYear}
        />

        <StackLayout
          gap={5}
          align={{ horizontal: 'end' }}
          style={{ marginTop: 10 }}
        >
          <Button
            onClick={handleReturn}
            className="pcy-button-short"
          >
            戻る
          </Button>

          <Button
            onClick={handleClickLoginBtn}
            themeColor="primary"
            className="pcy-button-short"
            disabled={userProp?.authority !== Authority.Builder}
          >
            登録
          </Button>
        </StackLayout>
      </Window>

      {confirmDialogShow && (
        <ConfirmDialog
          open={confirmDialogShow}
          title={title}
          id={dialogMsgId}
          renderCancelButton={renderCancelButton}
          args={args}
          onClickOk={handleConfirmEvent}
          onClickCancel={() => setConfirmDialogShow(false)}
        />
      )}
    </>
  )
}
